import { MONITORING_CONSTANTS } from '../types';

/**
 * Centralized ID generation utility for monitoring infrastructure
 */
export class IdGenerator {
  private static instance: IdGenerator;

  private constructor() {}

  static getInstance(): IdGenerator {
    if (!IdGenerator.instance) {
      IdGenerator.instance = new IdGenerator();
    }
    return IdGenerator.instance;
  }

  /**
   * Generate a unique transaction ID
   * Used by ActionTracker for individual user actions
   */
  generateTransactionId(): string {
    return `${
      MONITORING_CONSTANTS.TRANSACTION_ID_PREFIX
    }${Date.now()}_${this.generateRandomSuffix()}`;
  }

  /**
   * Generate a unique workflow ID
   * Used by TransactionCorrelator for workflow tracking
   */
  generateWorkflowId(): string {
    return `${
      MONITORING_CONSTANTS.WORKFLOW_ID_PREFIX
    }${Date.now()}_${this.generateRandomSuffix()}`;
  }

  /**
   * Generate a unique session ID
   * Used by ContextEnricher for session tracking
   */
  generateSessionId(): string {
    return `session_${Date.now()}_${this.generateRandomSuffix()}`;
  }

  /**
   * Generate a random suffix for IDs
   * Uses modern substring() instead of deprecated substr()
   */
  private generateRandomSuffix(): string {
    return Math.random().toString(36).substring(2, 11);
  }
}
